// extracted by mini-css-extract-plugin
export default {"iframe-preview":"WidgetPreview_iframe-preview__tDpl0"};